import ActionHandler from '@/js/components/forms/action_handler';
import { rootWithLanguage } from '@/js/utils/paths';

class Detail extends ActionHandler {
  constructor() {
    super();
    this.dom = {
      dropdownButtons: document.querySelectorAll('.dropdown-toggle'),
      dropdownItems: document.querySelectorAll('.dropdown-item'),
      dropdownTargetLabel: document.querySelector('.dropdown-toggle-label'),
      courseSubmitButton: document.getElementById('course-submit'),
    };

    this.data = {
      phaseID: null,
      courseID: null,
    };

    this.events = {
      onDropdownItemClick: this.onDropdownItemClick.bind(this),
      onCourseButtonClick: this.onCourseButtonClick.bind(this),
    };

    this.mount();
  }

  mount() {
    this.dom.dropdownItems.forEach((dropdownItem) => {
      dropdownItem.addEventListener('click', this.events.onDropdownItemClick);
    });

    this.dom.courseSubmitButton.addEventListener('click', this.events.onCourseButtonClick);
  }

  onDropdownItemClick(e) {
    e.stopPropagation();

    const selectedDropdownItem = e.currentTarget;

    // Close dropdown
    selectedDropdownItem.parentNode.parentNode.classList.remove('show');

    this.dom.dropdownItems.forEach((dropdownItem) => {
      dropdownItem.classList.remove('active');
    });

    selectedDropdownItem.classList.add('active');

    // Get the value of the dropdown label
    this.dom.dropdownTargetLabel.textContent = selectedDropdownItem.dataset.dropdownLabel;
    this.dom.dropdownButtons.forEach((dropdownButton) => {
      dropdownButton.setAttribute('aria-expanded', false);
      dropdownButton.classList.remove('show');
    });
  }

  onCourseButtonClick(e) {
    e.stopPropagation();
    e.preventDefault();

    const activeDate = document.querySelectorAll('.dropdown-item.active')[0];

    this.data.phaseID = activeDate.dataset.phaseId;
    this.data.courseID = activeDate.dataset.courseId;

    const formData = new FormData();
    formData.append('PhaseID', this.data.phaseID);
    formData.append('CourseID', this.data.courseID);
    this.send({ url: `${rootWithLanguage}course-register`, formData });
  }
}

if (document.getElementById('page-course-detail')) {
  // eslint-disable-next-line no-new
  new Detail();
}
